import { render } from "./HomeWhyMePhone.vue?vue&type=template&id=873c4e38&scoped=true"
const script = {}

import "./HomeWhyMePhone.vue?vue&type=style&index=0&id=873c4e38&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-873c4e38"]])

export default __exports__